var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.getNavigation==_vm.$options.LOGIN)?_c('Login'):_c('Navigation'),(_vm.getShowProductModal)?_c('ProductModal'):_vm._e(),(_vm.getShowEtichetteModal)?_c('EtichetteModal'):_vm._e(),(_vm.getShowCommentsModal)?_c('CommentsModal'):_vm._e(),_c('Receipt'),_c('Menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }